// Admin i18n — subscriptions & plan upgrade requests.
const en = {
  "admin.sub.title": "Plans & Subscriptions",
  "admin.sub.subtitle": "Review upgrade requests and manage artist plans",
  "admin.sub.tabRequests": "Upgrade requests",
  "admin.sub.tabUsers": "Users",
  "admin.sub.refresh": "Refresh",
  "admin.sub.retry": "Retry",
  "admin.sub.loadFailed": "Could not load data",
  "admin.sub.all": "All",
  "admin.sub.search": "Search name or email…",
  "admin.sub.user": "User",
  "admin.sub.email": "Email",
  "admin.sub.plan": "Plan",
  "admin.sub.badge": "Badge",
  "admin.sub.joined": "Joined",
  "admin.sub.actions": "Actions",
  "admin.sub.changePlan": "Change plan",
  "admin.sub.planUpdated": "Plan updated",
  "admin.sub.planUpdateFailed": "Could not update plan",
  "admin.sub.noUsers": "No users found",
  "admin.sub.req.pending": "Pending",
  "admin.sub.req.approved": "Approved",
  "admin.sub.req.rejected": "Rejected",
  "admin.sub.req.from": "From",
  "admin.sub.req.to": "Requested",
  "admin.sub.req.cycle.monthly": "Monthly",
  "admin.sub.req.cycle.yearly": "Yearly",
  "admin.sub.req.price": "Listed price",
  "admin.sub.req.note": "Note",
  "admin.sub.req.ticket": "Open ticket",
  "admin.sub.req.approve": "Approve & apply plan",
  "admin.sub.req.reject": "Reject",
  "admin.sub.req.approved_toast": "Plan applied and request approved",
  "admin.sub.req.rejected_toast": "Request rejected",
  "admin.sub.req.failed": "Action failed",
  "admin.sub.req.emptyTitle": "No upgrade requests",
  "admin.sub.req.emptyDesc": "When artists request a plan upgrade it will appear here.",
  "admin.sub.req.emptyFilter": "No requests with this status.",
  "admin.sub.req.paymentNote": "No payment provider is connected. Confirm payment with the artist before approving.",
  "admin.sub.req.decidedAt": "Decided {date}",
  "admin.sub.pendingCount": "{n} pending",
};

const tr = {
  "admin.sub.title": "Plan ve Abonelikler",
  "admin.sub.subtitle": "Yükseltme taleplerini inceleyin ve sanatçı planlarını yönetin",
  "admin.sub.tabRequests": "Yükseltme talepleri",
  "admin.sub.tabUsers": "Kullanıcılar",
  "admin.sub.refresh": "Yenile",
  "admin.sub.retry": "Tekrar dene",
  "admin.sub.loadFailed": "Veriler yüklenemedi",
  "admin.sub.all": "Tümü",
  "admin.sub.search": "İsim veya e-posta ara…",
  "admin.sub.user": "Kullanıcı",
  "admin.sub.email": "E-posta",
  "admin.sub.plan": "Plan",
  "admin.sub.badge": "Rozet",
  "admin.sub.joined": "Kayıt",
  "admin.sub.actions": "İşlemler",
  "admin.sub.changePlan": "Plan değiştir",
  "admin.sub.planUpdated": "Plan güncellendi",
  "admin.sub.planUpdateFailed": "Plan güncellenemedi",
  "admin.sub.noUsers": "Kullanıcı bulunamadı",
  "admin.sub.req.pending": "Bekliyor",
  "admin.sub.req.approved": "Onaylandı",
  "admin.sub.req.rejected": "Reddedildi",
  "admin.sub.req.from": "Mevcut",
  "admin.sub.req.to": "İstenen",
  "admin.sub.req.cycle.monthly": "Aylık",
  "admin.sub.req.cycle.yearly": "Yıllık",
  "admin.sub.req.price": "Liste fiyatı",
  "admin.sub.req.note": "Not",
  "admin.sub.req.ticket": "Talebi aç",
  "admin.sub.req.approve": "Onayla ve planı uygula",
  "admin.sub.req.reject": "Reddet",
  "admin.sub.req.approved_toast": "Plan uygulandı, talep onaylandı",
  "admin.sub.req.rejected_toast": "Talep reddedildi",
  "admin.sub.req.failed": "İşlem başarısız",
  "admin.sub.req.emptyTitle": "Yükseltme talebi yok",
  "admin.sub.req.emptyDesc": "Sanatçılar plan yükseltmesi istediğinde burada görünecek.",
  "admin.sub.req.emptyFilter": "Bu durumda talep yok.",
  "admin.sub.req.paymentNote": "Bağlı bir ödeme sağlayıcı yok. Onaylamadan önce ödemeyi sanatçıyla teyit edin.",
  "admin.sub.req.decidedAt": "Karar: {date}",
  "admin.sub.pendingCount": "{n} bekliyor",
};

const es = {
  "admin.sub.title": "Planes y suscripciones",
  "admin.sub.subtitle": "Revisa solicitudes de mejora y gestiona los planes de los artistas",
  "admin.sub.tabRequests": "Solicitudes de mejora",
  "admin.sub.tabUsers": "Usuarios",
  "admin.sub.refresh": "Actualizar",
  "admin.sub.retry": "Reintentar",
  "admin.sub.loadFailed": "No se pudieron cargar los datos",
  "admin.sub.all": "Todos",
  "admin.sub.search": "Buscar nombre o email…",
  "admin.sub.user": "Usuario",
  "admin.sub.email": "Email",
  "admin.sub.plan": "Plan",
  "admin.sub.badge": "Insignia",
  "admin.sub.joined": "Registro",
  "admin.sub.actions": "Acciones",
  "admin.sub.changePlan": "Cambiar plan",
  "admin.sub.planUpdated": "Plan actualizado",
  "admin.sub.planUpdateFailed": "No se pudo actualizar el plan",
  "admin.sub.noUsers": "No se encontraron usuarios",
  "admin.sub.req.pending": "Pendiente",
  "admin.sub.req.approved": "Aprobada",
  "admin.sub.req.rejected": "Rechazada",
  "admin.sub.req.from": "Actual",
  "admin.sub.req.to": "Solicitado",
  "admin.sub.req.cycle.monthly": "Mensual",
  "admin.sub.req.cycle.yearly": "Anual",
  "admin.sub.req.price": "Precio de lista",
  "admin.sub.req.note": "Nota",
  "admin.sub.req.ticket": "Abrir ticket",
  "admin.sub.req.approve": "Aprobar y aplicar plan",
  "admin.sub.req.reject": "Rechazar",
  "admin.sub.req.approved_toast": "Plan aplicado y solicitud aprobada",
  "admin.sub.req.rejected_toast": "Solicitud rechazada",
  "admin.sub.req.failed": "La acción falló",
  "admin.sub.req.emptyTitle": "No hay solicitudes de mejora",
  "admin.sub.req.emptyDesc": "Cuando un artista solicite una mejora de plan aparecerá aquí.",
  "admin.sub.req.emptyFilter": "No hay solicitudes con este estado.",
  "admin.sub.req.paymentNote": "No hay proveedor de pagos conectado. Confirma el pago con el artista antes de aprobar.",
  "admin.sub.req.decidedAt": "Decidida {date}",
  "admin.sub.pendingCount": "{n} pendientes",
};

export default { en, tr, es };
